import {
  REQUEST_DEVICES,
  RSPONSE_DEVICES,
  REQUEST_DEVICES_FAILURE,
  SELECT_DEVICE,
  CLEAR_DEVICES,
  REQUEST_PROTOCOL_MARKERS,
  RESPONSE_PROTOCOL_MARKERS,
  REQUEST_PROTOCOL_MARKERS_FAILURE,
  REQUEST_DEVICE_PATTERNS,
  RESPONSE_DEVICE_PATTERNS,
  REQUEST_DEVICE_PATTERNS_FAILURE,
  REQUEST_CREATE_DEVICE,
  RESPONSE_CREATE_DEVICE,
  REQUEST_CREATE_DEVICE_FAILURE,
} from "../actions/devicesAction";

import { states } from "./queriesStates";

const initialState = {
  dataStateDevices: states.NOT_REQUESTED,
  dataStateProtocolMarkers: states.NOT_REQUESTED,
  devicePatternsDataState: states.NOT_REQUESTED,
  createDeviceDataState: states.NOT_REQUESTED,
  devices: [],
  selectedDevice: null,
  protocolMarkers: null,
  devicePatterns: null,
  errors: [],
};

const devicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DEVICES:
      return Object.assign({}, state, {
        dataStateDevices: states.REQUEST,
        devices: [],
      });
    case RSPONSE_DEVICES:
      return Object.assign({}, state, {
        dataStateDevices: states.READY,
        devices: action.data.devices,
      });
    case REQUEST_DEVICES_FAILURE:
      return Object.assign({}, state, {
        dataStateDevices: states.FAILURE,
        errors: action.errors,
      });

    case SELECT_DEVICE:
      return Object.assign({}, state, {
        selectedDevice: action.data,
      });
    case CLEAR_DEVICES:
      return Object.assign({}, state, {
        devices: [],
        selectedDevice: null,
      });

    case REQUEST_PROTOCOL_MARKERS:
      return Object.assign({}, state, {
        dataStateProtocolMarkers: states.REQUEST,
        protocolMarkers: null,
      });
    case RESPONSE_PROTOCOL_MARKERS:
      return Object.assign({}, state, {
        dataStateProtocolMarkers: states.READY,
        protocolMarkers: action.data,
      });
    case REQUEST_PROTOCOL_MARKERS_FAILURE:
      return Object.assign({}, state, {
        dataStateProtocolMarkers: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_DEVICE_PATTERNS:
      return Object.assign({}, state, {
        devicePatternsDataState: states.REQUEST,
      });
    case RESPONSE_DEVICE_PATTERNS:
      return Object.assign({}, state, {
        devicePatternsDataState: states.READY,
        devicePatterns: action.data,
      });
    case REQUEST_DEVICE_PATTERNS_FAILURE:
      return Object.assign({}, state, {
        devicePatternsDataState: states.FAILURE,
        errors: action.errors,
      });

      case REQUEST_CREATE_DEVICE:
        return Object.assign({}, state, {
          createDeviceDataState: states.REQUEST,
        });
      case RESPONSE_CREATE_DEVICE:
        return Object.assign({}, state, {
          createDeviceDataState: states.READY,
        });
      case REQUEST_CREATE_DEVICE_FAILURE:
        return Object.assign({}, state, {
          createDeviceDataState: states.FAILURE,
          errors: action.errors,
        });

    default:
      return state;
  }
};

export default devicesReducer;
